// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3IAH-","row":"styles_row__2D3-C"};